<template>
	<div class="enquiry-form-controls">
		<div class="title">
			Upload new enquiry form
		</div>

		<UploadBox 
			theme="dark"
			:designation="designation"
			:maxFiles="1"
			:withName="true"
			@done="uploadingFinished"
			/>

	</div>
</template>

<script>

import UploadBox from '@/Components/Upload/UploadBox'

export default {
	components: {
		UploadBox
	},
	props: {
		designation: {
			type: String,
			required: true,
			default: 'enquiry-form'
		},
	},
	methods: {
		uploadingFinished(){
			this.$emit('done')
		}
	}
}

</script>

<style scoped lang="sass">

.enquiry-form-controls
	background-color: #181818
	width: 100%
	padding: 20px 25px
	border-radius: 8px
	min-height: 80px
	display: flex
	box-shadow: 0 1px 3px rgba(#000, 0.2)
	margin: -15px 0 30px
	border-bottom: 10px solid #70c2ff
	flex-direction: column

	.title
		font-family: 'Roboto Condensed', sans-serif
		color: #fff
		font-size: 21px
		font-weight: 700
		padding: 0 0 15px 0
		margin: 0

</style>